import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static values = {
    mode: { type: String, default: "date" },
  }

  connect() {
    this.initFlatpickr()
  }

  disconnect() {
    if (this.fp) {
      this.fp.destroy()
    }
  }

  initFlatpickr() {
    const mode = this.modeValue
    let options = {}

    if (mode === "time") {
      options = {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        altInput: true,
        altFormat: "h:i K",
        time_24hr: false,
      }
    } else if (mode === "datetime") {
      options = {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        altInput: true,
        altFormat: "F j, Y at h:i K",
      }
    } else {
      // date mode (default)
      options = {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "F j, Y",
      }
    }

    this.fp = flatpickr(this.element, options)
  }
}
